<template>
  <div>
    <div class="form-group">
        <label for="workflow_role_selected">{{__('forms.workflowsActor.role')}}</label>        
        <select v-model="role_selected" class="form-control" @change="reset()" required>
            <option v-for="obj, id in roles_with_status" :value="obj" v-bind:key="id">{{obj.name}}</option>
        </select>        
        <input type="hidden" v-model="role_selected.id" name="workflow_role_selected">        
    </div>
    <div class="form-group" v-if="status_view_select">
        <label for="workflow_status_selected">{{__('forms.workflowsActor.status')}}</label>
        <select v-model="status_selected" class="form-control" name="workflow_status_selected" required>
            <option v-for="status, statusId in role_selected.statuses" :value="status.id" v-bind:key="statusId">{{status.name}}</option>
        </select>
    </div>    
    <div v-if="status_view_cards">                
        <label v-if="role_selected.statuses != null" for="workflow_status_selected" class="fake-label">{{__('forms.workflowsActor.status')}}</label>
        <input type="hidden" v-model="status_selected" name="workflow_status_selected" required>        
        <div class="row form-group">
            <div class="col-3" v-for="status, statusId in role_selected.statuses" v-bind:key="statusId" @click="setStatusSelected(statusId)">                                
                <div class="single--task-legend single--task-legend cursor-pointer shadow m-1"  title="titolo" :style="{backgroundColor: statusId == status_selected ? '#D3D3D3' : 'white'}">
                    <div class="bar" :style="{backgroundColor: status.color}"></div>
                    <h4><i :class="'mr-2 fa ' + status.icon"></i>{{status.name}}</h4>
                </div>
            </div>                
        </div>
        <div class="alert alert-danger" role="alert" v-if="alert_visible && !(role_selected != null && status_selected != null)">
            {{ __("forms.workflowsActor.alert_print") }}
        </div>
        <div class="float-right">
            <button type="submit" class="btn btn--green" v-if="role_selected != null && status_selected != null">
                {{ __("misc.print") }}
            </button>
            <button type="button" class="btn btn--green" v-if="role_selected == null || status_selected == null" @click="showAlert()">
                {{ __("misc.print") }}
            </button>
        </div>
    </div>    
  </div>
</template>
<script>
export default {
  props: {    
    roles_with_status: {
      type: Object,
      required: true,
    },
    status_view_select: {
        type: Boolean,
        default: true
    },
    status_view_cards: {
        type: Boolean,
        default: false
    },
  },
  data() {
    return {
        role_selected: {
            statuses: null
        },
        status_selected: null,
        alert_visible: false
    };
  },
  methods: {    
    setStatusSelected(statusId){        
        this.status_selected = statusId;
    },
    reset(){
        this.status_selected = null;
    },
    showAlert(){
        this.alert_visible = true;
    }
  },
};
</script>

<style scoped>

.single--task-legend {  
    padding: 10px;
    border-radius: 6px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.04);
    position: relative;         
    min-height: 100px;    
  }
.single--task-legend .bar {
    position: absolute;
    content: "";
    width: 5px;
    border-radius: 5px;
    height: calc(100% - 20px);
    top: 10px;
    left: 10px;
}
.single--task-legend h4{
    margin-left: 15px;    
    margin-top: 2rem;
    font-weight: 700;
    line-height: 1.3;       
 }
.single--task-current {
    background-color: rgba(0.2);    
 }
.single--task-current:before {
    background-color: white;
}
.fake-label{
    font-size: 16px;
    color: #9CA3AF;
    font-weight: normal;
}
</style>